<coin-v2-dialog-frame [header]="'season-mgmt.incentive.monitoring.records.details.edit-field' | translate">
  <div class="body-container">
    <div class="inner-content">
      <coin-v2-dropdown
        required
        style="width: 100%; margin: 10px 0"
        label="Select Season Plan"
        matFormFieldClass="shadow"
        [compareWith]="compare"
        [(ngModel)]="data.value">
        @for (plan of plans(); track plan.id) {
          <ng-template [coinValue]="plan">{{ displayFn(plan) }}</ng-template>
        }
      </coin-v2-dropdown>
    </div>
  </div>
  <coin-v2-dialog-footer color="white">
    <coin-v2-button
      type="secondary"
      icon="close"
      iconPos="right"
      [text]="'general.btnCancel' | translate"
      (click)="cancel()"></coin-v2-button>
    <coin-v2-button
      type="primary"
      icon="save"
      iconPos="right"
      [text]="'general.btnUpdate' | translate"
      (click)="save()"></coin-v2-button>
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
